import { googletagDisplay } from './display';
import { googletagDisplayAgain } from './display-again';
import { googletagDestroySlots } from './destroy-slots';
import { googletagRefresh } from './refresh';

const { services, googletagServices } = window.adTechConfig;

const googletagIsOn = () => {
	return services.googletag ? services.googletag : false;
};

const allowSectionAdsSingleDisplay = () => {
	return googletagServices.allow_section_ads_single_display ? googletagServices.allow_section_ads_single_display : true;
};

/**
 * Googletag features for the site.
 */
export const googletag = {
	slotDefineFunctions: {},
	slots: {},
	isOn: googletagIsOn,
	display: googletagDisplay,
	refresh: googletagRefresh,
	displayAgain: googletagDisplayAgain,
	destroySlots: googletagDestroySlots,
	allowSectionAdsSingleDisplay,
};